import LofiTrain from '../assets/LofiTrainRaphaelAlcantara.mp4'
import outline from '../assets/outline.mp4'
import matcha from '../assets/Video_Matcha.mp4'
import frame from '../assets/frame.mp4'
import montre from '../assets/montre.mp4'
import showreel from '../assets/Showreel.mp4'
import Coffee from '../assets/coffee.mp4'
import Mango from '../assets/Mango_Pull.mp4'
import concreto from '../assets/Concreto.mp4'
import mixMedia from '../assets/mixMedia.mp4'
import generique from '../assets/generique.mp4'
import documentaire from '../assets/documentaire.mp4'

import FooterRelative from '../components/FooterRelative'
import Model3D from '../components/Model3d'
import Pong from '../assets/pong.PNG'
import bdMedia1 from '../assets/bdMedia1.PNG'
import bdMedia2 from '../assets/bdMedia2.PNG'
import rentRoom1 from '../assets/rentRoom1.PNG'
import rentRoom2 from '../assets/rentRoom2.PNG'
import miniatureMontre from '../assets/miniatureMontre.png'
import miniatureLine from '../assets/miniatureLine.png'
import miniatureShowreel from '../assets/miniatureShowreeel.png'
import miniatureFrame from '../assets/miniature_frame.png'
import miniatureConcreto from '../assets/miniature_concreto.jpg'
import miniatureGenerique from '../assets/miniature_generique.png'
import miniatureDocumentaire from '../assets/miniature_documentaire.png'
import miniatureMatcha from '../assets/miniature_matcha.png'
import miniatureMango from '../assets/miniature_mango.png'
import miniatureMixMedia from '../assets/miniature_mixmedia.png'
import miniatureLofi from '../assets/miniature_train.png'
import miniatureCoffee from '../assets/miniature_coffee.png'

function Projets(){
    return(
        <div>
           <div className="container">
            <h1>PROJETS</h1>
            <Model3D/>
            <h2>Mes vidéos de motion Design</h2>
                <div className="image_container">
                <h3>Showreel 2026</h3> 
                <p>
                Voici mon showreel rassemblant mes principaux projets personnels, illustrant mon univers créatif ainsi que les compétences que j'ai développé en motion design.
                </p>
                <video src={showreel} controls="controls" controlsList="nodownload"  type="video/mp4"  preload="none" poster={miniatureShowreel} />
                
                <h3>Workshop Branding </h3>
                <p>Ce workshop est un projet de groupe de deux semaines où on devait réaliser un branding d'un festival urbain sur le thème de la musique classique. Ce projet s'appelle Concreto, nous avons dû réaliser
                l'identité graphique (logo, couleurs, typographies), les déclinaisons sur les différents supports print et digitaux (affiches, post réseaux sociaux) et la réalisation d'un mapping. 
               <br></br> <br></br>
                Voici notre case study, voir ci-dessous :
                </p>
                <video src={concreto} controls="controls" controlsList="nodownload"  type="video/mp4"  preload="none" poster={miniatureConcreto}  />
                
                  
                <h3>Workshop Générique </h3>
                <p>Pour ce workshop de générique de film, j'ai choisi Bullet Train, sorti en 2022 et réalisé par David Leitch. Dans ce film, les personnages 
                    sont principalement désignés par des surnoms tels que Ladybug, Tangerine, The Wolf ou encore Lemon. À travers mon générique, je souhaite mettre 
                    en avant ces différents éléments afin de refléter leur personnalité, leur identité et l'univers singulier propre à chacun d'eux.
                </p>
                <video src={generique} controls="controls" controlsList="nodownload"  type="video/mp4"  preload="none" poster={miniatureGenerique} />

                <h3>Workshop Documentaire </h3>
                <p>Pour ce workshop, j'ai choisi de réaliser un trailer documentaire sur les samouraïs. À travers les films, les animés, les jeux vidéo, les mangas et les récits historiques. 
                    les samouraïs sont souvent représentés comme des héros mythiques et honorables. Pourtant, la réalité de leur existence était bien plus sombre et angoissante. Ils vivaient 
                    dans un contexte de guerre permanente et devaient respecter rigoureusement le code du bushidō, sous peine de déshonneur ou même de mort. 
                </p>
                <video src={documentaire} controls="controls" controlsList="nodownload"  type="video/mp4"  preload="none" poster={miniatureDocumentaire}/>

                <h3>Matcha coffee</h3>
                <p>
                Ce projet marque ma première exploration sur Blender, que j'ai appris en autodidacte en parallèle de mon cursus. 
                Il m'a permis d'expérimenter la composition, le rendu 3D et le mouvement de caméra à travers la création d'un matcha shop 
                à l'ambiance chaleureuse et minimaliste. Une étape clé dans mon apprentissage et dans l'affirmation de ma sensibilité visuelle.
                </p>
                <video src={matcha} controls="controls" controlsList="nodownload"  preload="none"  type="video/mp4" poster={miniatureMatcha}   />


        
                  <h3>Illustration animée</h3>
                <p>
                Projet realisé lors d'un workshop en illustration animee, ou j'ai experimente pour la premiere fois le dessin en frame by frame.
                Inspire du split screen, il illustre un extrait audio en traduisant son energie par le mouvement, tout en me permettant d'explorer de nouvelles techniques d'animation en dehors d'After Effects.
                </p>
                <video src={frame} controls="controls" controlsList="nodownload"  type="video/mp4"  preload="none" poster={miniatureFrame}  />

                <h3>The Pull-Up Mango</h3>
                <p>Un fruit, une barre, une boucle. Cette animation explore la frontière 
                entre l'absurde et le minimalisme à travers une mangue en pleine séance de tractions.</p>
                <video src={Mango} controls="controls" controlsList="nodownload"  preload="none"  type="video/mp4"  poster={miniatureMango}/>

                
                <h3>MixMedia</h3>
                <p>Ce projet est un travail de groupe où nous avons dû travailler à partir du morceau "pink + pink" de Rusowsky (ft. Ravyn Lenae). 
                    L’objectif de ce projet était de retranscrire visuellement l’univers artistique du musicien à travers une approche expérimentale en utilisant différentes techniques manuelles.
                </p>
                <video src={mixMedia} controls="controls" controlsList="nodownload"  preload="none"  type="video/mp4" poster={miniatureMixMedia} />


                <h3>Lo-Fi Railway</h3>
                <p>Cette vidéo est le fruit d'un projet réalisé lors de mes derniers cours de motion design, visant à valider l'ensemble des bases acquises. Développé sur plusieurs semaines, 
                    il s'inspire fortement du style d'animation des vidéos de Lofi Girl, où les boucles infinies créent une atmosphère apaisante et immersive.
                </p>
                <video src={LofiTrain} controls="controls" controlsList="nodownload"  preload="none" type="video/mp4"  poster={miniatureLofi} />
                
                <h3>Coffee</h3>                
                <p>J'ai réalisé une vidéo animée sur le thème du café, alliant ma passion pour le motion design à mon expérience dans l'univers du café. 
                    À travers des animations fluides et des couleurs chaleureuses, j'ai cherché à retranscrire son ambiance unique. Cette création reflète mon évolution 
                    professionnelle et mon envie de raconter des histoires visuellement percutantes.
                </p>
                <video src={Coffee} controls="controls" controlsList="nodownload"   preload="none" type="video/mp4" poster={miniatureCoffee} />
                
                <h3>Pitchy</h3>
                <p>Pour valider mon diplôme de DUT MMI, j'ai effectué un stage de fin d'année au sein de l'entreprise Pitchy, spécialisée dans la création de vidéos en motion design. 
                    Voici quelques-uns des projets auxquels j'ai contribué durant cette expérience.
                </p>
                <video src={montre} controls="controls" controlsList="nodownload"  preload="none" poster={miniatureMontre}/>
                <video src={outline} controls="controls" controlsList="nodownload"  preload="none" poster={miniatureLine}/>

              

                </div>
            <h2>Pong</h2>
            <p>Passionné de jeux vidéo et particulièrement du jeu Pong, j'ai choisi de le recréer en lui apportant mon propre design. 
            <a href="https://raphalalc.github.io/Pong-Game/" target="_blanc"> Lien du jeu </a>
            </p>
             <div className="image_container">
                    <a href="https://raphalalc.github.io/Pong-Game/" target="_blanc"><img id="pong"src={Pong} alt="Pong"/> </a>
                    
                </div>

           

               
            <h2>BD Media</h2>
            <p>Application web pour lister toutes les séries BD, afficher les séries selon des mots-clés ou origine, afficher une série au hasard, application en CRUD, afficher les albums de la série
            et affichage des statistiques. Les technologies utilisées sont : HTML, SCSS, PHP en programmation orienté objet, MySQL et Git.
            </p>
            <div className="image_container">
            <a href="https://github.com/Raphalalc/POO_Project-BD-MEDIA" target="_blanc"><img className="img"src={ bdMedia1} alt="BD media github website"/> </a> 
            <a href="https://github.com/Raphalalc/POO_Project-BD-MEDIA" target="_blanc"><img className="img"src={ bdMedia2} alt="BD media github website"/> </a> 
            </div>
            <h2>RentRoom</h2> 
            <p>Site de réservation de salle en ligne, création de la page inscription et connexion, affichage des salles qui ne sont pas réservés et disponible selon la date actuelle,
               création de la page admin, affichage des informations de la salle et création du bouton réservation.
               Les technologies utilisées sont : HTML, SCSS, JavaScript, programmation procédurale PHP, mySQL et Git.
            </p>
            <div className="image_container">
            <a href="https://github.com/Raphalalc/rentroom" target="_blanc"><img className="img"src={rentRoom1} alt="RentRoom website"/> </a> 
            <a href="https://github.com/Raphalalc/rentroom" target="_blanc"><img className="img"src={rentRoom2} alt="RentRoom website"/> </a> 
            </div>

            </div>
            <FooterRelative />
        </div>
    )
}

export default Projets;